import { render, staticRenderFns } from "./DeleteFileModal.vue?vue&type=template&id=53af9089&"
import script from "./DeleteFileModal.vue?vue&type=script&lang=js&"
export * from "./DeleteFileModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteFileModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports